import { Hat } from '../objects/Hat';
import { Character } from '../objects/Character';
import { HitType } from '../types';

export class HitDetection {
  static check(hat: Hat, character: Character): HitType | null {
    if (!hat.trajectory || !hat.trajectory.willHit) return null;
    return hat.trajectory.hitType;
  }
}
